export function useBindingPeriodNotification() {
  const checkoutStore = useMyCheckoutStore();
  const notifications = useNotificationStore();

  const isActive = computed(
    () => checkoutStore.ui.bindingPeriodCheckHasActiveBinding === true,
  );

  watch(isActive, (active) => {
    if (active) {
      setBindingNotification();
    } else {
      notifications.reset();
    }
  });

  // MAV-3307: Re-check after any notification reset in checkout if
  // the aleady has binding period condition is still active,
  // in that case we want this error notifcation to take precedence
  // and still appear
  notifications.$onAction(({ name, after }) => {
    if (name === 'reset') {
      after(() => {
        if (isActive.value) {
          setBindingNotification();
        }
      });
    }
  });

  onBeforeRouteLeave(() => {
    checkoutStore.ui.bindingPeriodCheckHasActiveBinding = null;
  });

  function setBindingNotification() {
    notifications.setNewNotification({
      type: 'error',
      isCloseable: false,
      title: 'Du har redan ett aktivt abonnemang med bindningstid.',
      msg: 'Det går inte att teckna ett nytt abonnemang medan du har en aktiv bindningstid.',
      link: { url: '', text: '' },
    });
  }
}
